module.exports = __webpack_public_path__ + "static/media/logo.ef86b7a2.svg";